import { Entity } from '../../entity';

export type VisitAssignmentAction = 'crew' | 'contractor' | 'restore';

/** Dialog values; an empty crew or null contractor is an explicit Visit-only clear. */
export interface VisitAssignmentSelection {
    resources: Entity[];
    contractor: Entity | null;
}

export interface VisitAssignmentRequest {
    id: string;
    action: VisitAssignmentAction;
    resources?: Entity[];
    contractor?: Entity | null;
}

export const VISIT_ASSIGNMENT_COMMAND = 'VisitAssignmentCommand';
